import React, { useContext } from 'react';
import { Progress } from 'antd';

import Category from '@totem/components/surveyV2/instance/Category';
import SurveyContext from '@totem/components/surveyV2/instanceDetail/SurveyInstanceContext';
import IBTabs from '@totem/components/ui_components/antDesignOverrides/IBTabs';
import { ScoredCategory } from '@totem/types/survey';
import { sortNumberAscending } from '@totem/utilities/tableUtilities';

import '../survey.css';

const styles = {
  progress: {
    width: '32rem',
  },
};

const SurveyInstance = () => {
  const { data, errors, filterAnswered } = useContext(SurveyContext);
  const { survey } = data;

  const categoryHasError = ({ id }: ScoredCategory) => {
    return errors.some(({ categoryId }) => categoryId === id);
  };

  const getCategoryName = (category: ScoredCategory): string => {
    const { name, completedQuestions, totalQuestions } = category;
    return `${name} (${completedQuestions}/${totalQuestions})`;
  };

  const getTabBarExtra = () => {
    const { completedQuestions, totalQuestions } = survey;
    const percent = Math.round((completedQuestions / totalQuestions) * 100);

    return (
      <div>
        <div styleName="progress-label">Progress</div>
        <Progress percent={percent} style={styles.progress} />
      </div>
    );
  };

  const getTabItems = () => {
    const { categories } = survey;
    const visibleCategories = categories.filter((cat) => cat.visible === true);

    const sortedCategories = visibleCategories.sort((compA, compB) =>
      sortNumberAscending(compA.index, compB.index),
    );

    return sortedCategories.map((category) => {
      return {
        key: category.id,
        label: (
          <div styleName={categoryHasError(category) ? 'category-error' : ''}>
            {getCategoryName(category)}
          </div>
        ),
        children: (
          <div>
            <Category
              category={category}
              disabled={survey.isSubmitted}
              filterAnswered={filterAnswered}
            />
          </div>
        ),
      };
    });
  };

  return (
    <IBTabs
      hideAdd
      size="large"
      items={getTabItems()}
      tabBarExtraContent={getTabBarExtra()}
    />
  );
};

export default SurveyInstance;
